export function toFinite(n: number): number {
    return Number.isFinite(n) ? n : 0;
}
